import React from "react";
import "../../assets/css/Seller_Inventory.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { detail_order_img, product_inventory } from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_Inventory = () => {
	function addproduct() {
		window.location.href = "/seller-add-product";
	}
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8">
							<Seller_tabs_list />

							<div className="sellers_orders">
								<div className="heading_wrapper d-flex justify-content-between">
									<h4>Product Inventory</h4>
									<div className="input-group">
										<div className="form-outline">
											<input
												type="search"
												placeholder="Search Products"
												id="form1"
												className="form-control"
											/>
										</div>
										<button type="button" className="btn btn-primary">
											<i className="fas fa-search"></i>
										</button>
									</div>
									<div className="add-upload-wrapper">
										<button className="add-products" onClick={addproduct}>
											Add
										</button>
									</div>
								</div>

								<div className="table-resposnive mt-4">
									<table className="table">
										<thead style={{ width: "946px" }}>
											<tr className="topbar">
												<th scope="col" className="Status">
													Status
												</th>
												<th scope="col" className="billingname">
													Product Name
												</th>
												<th scope="col" className="amount">
													SKU number
												</th>
												<th scope="col" className="Image">
													Image
												</th>
												<th scope="col" className="shipmentstatus">
													Date
												</th>
												<th scope="col" className="Price">
													Price
												</th>
												<th scope="col" className="Stock">
													Stock Available
												</th>
												<th scope="col" className="Details">
													Details
												</th>
												<th scope="col" className="Action">
													Action
												</th>
											</tr>
										</thead>
										<tbody>
											<tr style={{ width: "946px" }}>
												<td className="orderid">Active</td>
												<td className="billingname">Koizuma Massage Gun </td>
												<td className="amount">CA12345</td>
												<td className="items">
													<img
														src={product_inventory}
														className="pro-table-img"
														alt=""
													/>
												</td>
												<td className="shipmentstatus">Mon 11 July 2021 </td>
												<td className="details">$300 </td>
												<td className="Available">0 </td>

												<td className="Detailsu">
													<button
														onClick={() =>
															(window.location.href =
																"/seller-product-inventory")
														}
														className="btn details-btn"
													>
														View Details
													</button>{" "}
												</td>
												<td className="Detailsu">
													<div className="button-wrap">
														<button className="edit">
															<i
																className="fa fa-pencil"
																aria-hidden="true"
															></i>
														</button>
														<button className="edit">
															<i className="fa fa-trash" aria-hidden="true"></i>
														</button>
													</div>
												</td>
											</tr>
											<tr>
												<td className="orderid">Active</td>
												<td className="billingname">Koizuma Massage Gun </td>
												<td className="amount">CA12345</td>
												<td className="items">
													<img
														src={product_inventory}
														className="pro-table-img"
														alt=""
													/>
												</td>
												<td className="shipmentstatus">Mon 11 July 2021 </td>
												<td className="details">$300 </td>
												<td className="Available">0 </td>

												<td className="Detailsu">
													<button className="btn details-btn">
														View Details
													</button>{" "}
												</td>
												<td className="Detailsu">
													<div className="button-wrap">
														<button className="edit">
															<i
																className="fa fa-pencil"
																aria-hidden="true"
															></i>
														</button>
														<button className="edit">
															<i className="fa fa-trash" aria-hidden="true"></i>
														</button>
													</div>
												</td>
											</tr>
											<tr>
												<td className="orderid">Active</td>
												<td className="billingname">Koizuma Massage Gun </td>
												<td className="amount">CA12345</td>
												<td className="items">
													<img
														src={product_inventory}
														className="pro-table-img"
														alt=""
													/>
												</td>
												<td className="shipmentstatus">Mon 11 July 2021 </td>
												<td className="details">$300 </td>
												<td className="Available">0 </td>

												<td className="Detailsu">
													<button className="btn details-btn">
														View Details
													</button>{" "}
												</td>
												<td className="Detailsu">
													<div className="button-wrap">
														<button className="edit">
															<i
																className="fa fa-pencil"
																aria-hidden="true"
															></i>
														</button>
														<button className="edit">
															<i className="fa fa-trash" aria-hidden="true"></i>
														</button>
													</div>
												</td>
											</tr>
											<tr>
												<td className="orderid">Active</td>
												<td className="billingname">Koizuma Massage Gun </td>
												<td className="amount">CA12345</td>
												<td className="items">
													<img
														src={product_inventory}
														className="pro-table-img"
														alt=""
													/>
												</td>
												<td className="shipmentstatus">Mon 11 July 2021 </td>
												<td className="details">$300 </td>
												<td className="Available">0 </td>

												<td className="Detailsu">
													<button className="btn details-btn">
														View Details
													</button>{" "}
												</td>
												<td className="Detailsu">
													<div className="button-wrap">
														<button className="edit">
															<i
																className="fa fa-pencil"
																aria-hidden="true"
															></i>
														</button>
														<button className="edit">
															<i className="fa fa-trash" aria-hidden="true"></i>
														</button>
													</div>
												</td>
											</tr>
											<tr>
												<td className="orderid">Active</td>
												<td className="billingname">Koizuma Massage Gun </td>
												<td className="amount">CA12345</td>
												<td className="items">
													<img
														src={product_inventory}
														className="pro-table-img"
														alt=""
													/>
												</td>
												<td className="shipmentstatus">Mon 11 July 2021 </td>
												<td className="details">$300 </td>
												<td className="Available">0 </td>

												<td className="Detailsu">
													<button className="btn details-btn">
														View Details
													</button>{" "}
												</td>
												<td className="Detailsu">
													<div className="button-wrap">
														<button className="edit">
															<i
																className="fa fa-pencil"
																aria-hidden="true"
															></i>
														</button>
														<button className="edit">
															<i className="fa fa-trash" aria-hidden="true"></i>
														</button>
													</div>
												</td>
											</tr>
											<tr>
												<td className="orderid">Active</td>
												<td className="billingname">Koizuma Massage Gun </td>
												<td className="amount">CA12345</td>
												<td className="items">
													<img
														src={product_inventory}
														className="pro-table-img"
														alt=""
													/>
												</td>
												<td className="shipmentstatus">Mon 11 July 2021 </td>
												<td className="details">$300 </td>
												<td className="Available">0 </td>

												<td className="Detailsu">
													<button className="btn details-btn">
														View Details
													</button>{" "}
												</td>
												<td className="Detailsu">
													<div className="button-wrap">
														<button className="edit">
															<i
																className="fa fa-pencil"
																aria-hidden="true"
															></i>
														</button>
														<button className="edit">
															<i className="fa fa-trash" aria-hidden="true"></i>
														</button>
													</div>
												</td>
											</tr>
											<tr>
												<td className="orderid">Active</td>
												<td className="billingname">Koizuma Massage Gun </td>
												<td className="amount">CA12345</td>
												<td className="items">
													<img
														src={product_inventory}
														className="pro-table-img"
														alt=""
													/>
												</td>
												<td className="shipmentstatus">Mon 11 July 2021 </td>
												<td className="details">$300 </td>
												<td className="Available">0 </td>

												<td className="Detailsu">
													<button className="btn details-btn">
														View Details
													</button>{" "}
												</td>
												<td className="Detailsu">
													<div className="button-wrap">
														<button className="edit">
															<i
																className="fa fa-pencil"
																aria-hidden="true"
															></i>
														</button>
														<button className="edit">
															<i className="fa fa-trash" aria-hidden="true"></i>
														</button>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div className="paginations_results">
									<div className="showing_results">
										<p>
											Showing <b>7</b> of over 50 <b>results</b>
										</p>
									</div>
									<ul className="paginations">
										<li className="arrow prev-arrow">
											<i className="fa fa-angle-left" aria-hidden="true"></i>
										</li>
										<li className="pagi">1</li>
										<li className="pagi">2</li>
										<li className="pagi">3</li>
										<li className="pagi">..</li>
										<li className="pagi">90</li>
										<li className="arrow right-arrow">
											<i className="fa fa-angle-right" aria-hidden="true"></i>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_Inventory;
